import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import {TicketVo} from '../../common/shared/api/gateway/TicketVo.interface';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';

/**
 * 무료 이용권 확인
 *
 * Origin: pageNicolasApi.checkFreeTicket
 * API: GET /api/v1/ticket/free_check
 */
export async function getTicketFreeCheck(
  {
    seriesId,
  }: {
    seriesId: number;
  },
  options?: FetcherOptions
): Promise<ApiResultVo & {result: {list: TicketVo[]}}> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/ticket/free_check',
    {
      method: 'GET',
      params: {
        series_id: seriesId,
      },
    },
    options
  );
  return response.data;
}
